<template>
  <div class="contract">
    <mt-header title="创建签名" >
      <mt-button icon="back" slot="left" @click="goBack">返回</mt-button>
    </mt-header>
    <div class="qrmain">
    <div class="canvasdiv">
        <canvas id="canvas">
            您的浏览器不支持canvas
        </canvas>
    </div>
      <div id="controller">
          <div class="fl cx">请选择笔画粗细</div>
          <div class="fl cirpaint">
            <div @click="selSmall()" class="color_btn small" :class="{ color_btn_selected: selected1 }"></div>
          </div>
          <div class="fl cirpaint">
            <div @click="selMid()" class="color_btn big" :class="{ color_btn_selected: selected2 }"></div>
          </div>
          <div class="fl cirpaint">
            <div @click="selBig()" class="color_btn big2" :class="{ color_btn_selected: selected3 }"></div>
          </div>
          <div v-if="seenPage==1">
            <mt-button type="primary" size="small" class="fr mrb" @click="saveSign('1')">保存</mt-button>
          </div>
          <div v-else-if="seenPage === 2">
            <mt-button type="primary" size="small" class="fr mrb" @click="saveSign('2')">保存</mt-button>
          </div>
          <mt-button plain type="primary" size="small" class="fr mrb" @click="close()">清除</mt-button>
          <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast,Indicator } from 'mint-ui';
import cheader from '@/components/header';
export default {
  data () {
    return {
      canvasWidth : 300,
      canvasHeight : 300,
      strokeColor : "black",
      isMouseDown : false,
      lastLoc : {x:0,y:0},
      lastTimestamp : 0,
      lastLineWidth : 3,
      selected1:true,
      selected2:false,
      selected3:false,
      canvas:'',
      context:'',
      touch:'',
      returnRouterPath:'',
      _selected:'',
      seenPage:this.$route.query.seenPage,
      signatureList:'',
      pushList:''
    }
  },
  mounted(){
    this.canvas = document.getElementById("canvas");
    this.context = canvas.getContext("2d");
    this.canvas.width = this.canvasWidth;
    this.canvas.height = this.canvasHeight;
    this.addEventListeners();
    let params = this.$route.query;
    this.returnRouterPath = params.returnRouterPath;
    if(this.seenPage == 2){
      this.signatureList = eval(params.signatureList);
      this.pushList = eval(params.pushList);
    }
    this._selected= params._selected;
  },
  methods: {
    addEventListeners:function(){
      var that = this;
      this.canvas.addEventListener('touchstart',function(e){
          e.preventDefault();
          that.touch = e.touches[0];
          that.beginStroke( {x: that.touch.pageX , y: that.touch.pageY} );
      })
      this.canvas.addEventListener('touchmove',function(e){
          e.preventDefault();
          if( that.isMouseDown ){
              that.touch = e.touches[0];
              that.moveStroke({x: that.touch.pageX , y: that.touch.pageY});
          }
      })
      this.canvas.addEventListener('touchend',function(e){
          e.preventDefault();
          that.endStroke();
      })
    },
    close: function(){
      this.context.clearRect( 0 , 0 , this.canvasWidth, this.canvasHeight );
    },
    selSmall: function(){
      this.lastLineWidth = 3;
      this.selected1 = true;
      this.selected2 = false;
      this.selected3 = false;
    },
    selMid: function(){
      this.lastLineWidth = 6;
      this.selected1 = false;
      this.selected2 = true;
      this.selected3 = false;
    },
    selBig: function(){
      this.lastLineWidth = 9;
      this.selected1 = false;
      this.selected2 = false;
      this.selected3 = true;
    },
    beginStroke: function(point){
      this.isMouseDown = true;
      this.lastLoc = this.windowToCanvas(point.x, point.y);
    },
    endStroke: function(){
      this.isMouseDown = false;
    },
    moveStroke: function(point){
      var curLoc = this.windowToCanvas( point.x , point.y );
      this.context.beginPath();
      this.context.moveTo( this.lastLoc.x , this.lastLoc.y );
      this.context.lineTo( curLoc.x , curLoc.y );
      this.context.strokeStyle = this.strokeColor;
      this.context.lineWidth = this.lastLineWidth;
      this.context.lineCap = "round";
      this.context.lineJoin = "round";
      this.context.stroke();
      this.lastLoc = curLoc;
    },
    calcDistance: function( loc1 , loc2 ){
      return Math.sqrt( (loc1.x - loc2.x)*(loc1.x - loc2.x) + (loc1.y - loc2.y)*(loc1.y - loc2.y) );
    },
    windowToCanvas: function(x , y){
      var bbox = this.canvas.getBoundingClientRect();
      return {x:Math.round(x-bbox.left) , y:Math.round(y-bbox.top)};
    },
    scaleCanvas: function(oCanvas, iWidth, iHeight){
      if (iWidth && iHeight) {
        var oSaveCanvas = document.createElement("canvas");
        oSaveCanvas.width = iWidth;
        oSaveCanvas.height = iHeight;
        oSaveCanvas.style.width = iWidth+"px";
        oSaveCanvas.style.height = iHeight+"px";
        var oSaveCtx = oSaveCanvas.getContext("2d");
        oSaveCtx.drawImage(oCanvas, 0, 0, oCanvas.width, oCanvas.height, 0, 0, iWidth, iWidth);
        return oSaveCanvas;
      }
      return oCanvas;
    },
    saveSign: function(num){
	  if(this.isCanvasBlank()){
		  Toast("签名不能为空")
		  return false;
	  }
      var canvas = document.getElementById("canvas");
      var oScaledCanvas = this.scaleCanvas(canvas, 200, 200);
      var imageData = oScaledCanvas.toDataURL('image/png');
      var _headSign_url = domain("_headSign");
      this.$http.post(
        _headSign_url,
        {
          imageData:imageData,
          type:num
        },
        {emulateJSON: true}
        )
        .then(function (response) {  //接口返回数据
            if(response.data.code=='1'){
                var temp = response.data.data.temp;
                //跳转到合同签署页面
                this.$router.push({name: 'sign', query:{'cid': this.$route.query.cid,'cpage': this.$route.query.cpage,'regsw':response.data.data.registerSignId,'temp': temp,'signatureList':JSON.stringify(this.signatureList),'pushList':JSON.stringify(this.pushList)}});
            }else if(response.data.code=='0'){
                history.go(-1); //后退1页
            }else{
                Toast(response.data.msg)
            }
        }, function (error) {
          console.log(error);
          //Toast("数据获取响应异常.")
        }).catch(function (response) {
        console.log(response);
        //Toast("数据获取响应异常.")
        Indicator.close();
      })
    },
    addSignPage: function(){
    //   if(this.isCanvasBlank()){
	// 	  Toast("签名不能为空")
	// 	  return false;
	//   }
    //   var canvas = document.getElementById("canvas");
    //   var oScaledCanvas = this.scaleCanvas(canvas, 200, 200);
    //   var imageData = oScaledCanvas.toDataURL('image/png');
    //   var _headSign_url = domain("_headSignFromSign");
    //   this.$http.post(
    //     _headSign_url,
    //     {
    //       imageData:imageData
    //     },
    //     {emulateJSON: true}
    //     )
    //     .then(function (response) {
    //       if(response.data.code=='1'){
    //         var temp = response.data.data.temp;
    //         //跳转到合同签署页面
    //         this.$router.push({name: 'sign', query:{'cid': this.$route.query.cid,'cpage': this.$route.query.cpage,'regsw':response.data.data.registerSignId,'temp': temp,'signatureList':JSON.stringify(this.signatureList),'pushList':JSON.stringify(this.pushList)}});
    //       }
    //     }, function (error) {
    //       console.log(error);
    //       //Toast("数据获取响应异常.")
    //     }).catch(function (response) {
    //     console.log(response);
    //     //Toast("数据获取响应异常.")
    //     Indicator.close();
    //   })
    },
    goBack:function () {
      history.go(-1); //后退1页
    },
    isCanvasBlank: function() {
	    var blank = document.createElement('canvas');//系统获取一个空canvas对象
	    blank.width = this.canvas.width;
	    blank.height = this.canvas.height;
	    return this.canvas.toDataURL() == blank.toDataURL();//比较值相等则为空
	}
  },
  components:{
    cheader
  }
}
</script>
<style>
.contract .reftitle{
  background-color: #1f74d8;
}
.contract .reftitle img{
  width:14px;
}

#canvas{
    display:block;
    margin:0 auto;
}
#controller{
    margin:5px auto;
    position: relative;
}
.op_btn{
    float: right;
    margin:10px 0 0 10px;
    width:45px;
    height:20px;
    line-height:20px;
    font-size:14px;
    text-align:center;
    border-radius: 2px 2px;
    cursor:pointer;
    background-color: #00c9d2;
    color: #ffffff;
}
.clearfix{
    clear:both;
}
.cx{
  margin: 12px 10px 0 0;
  font-size:0.8rem;
  color: #7d7d7d;
}
.color_btn{
    position:absolute;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    cursor:pointer;
    background-color: black;
}
.qrmain{width:302px;margin:0 auto;margin-top:20px;position:relative;}
#controller{width:302px;}
.canvasdiv{
    width:302px;
    height:302px;
    border:1px solid #d4d4d4;
    margin:0 auto;margin-top:5px;
}
.cirpaint{
  width:16px;
  height:16px;
  margin-top:10px;
}
.small{
  width:9px;
  height:9px;
  margin:7px 0 0 6px;
}
.big{
  width:12px;
  height:12px;
  margin:5px 0 0 14px;
}
.big2{
  width:15px;
  height:15px;
  margin:3px 0 0 25px;
}
.color_btn_selected{
  background-color: #10a0e9;
}
.mrb{
  margin:5px 0 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/module/signature/Signature.vue